// extracted by mini-css-extract-plugin
module.exports = {"statusColumn":"table-header_statusColumn__2mvFm","childLabel":"table-header_childLabel__3D7M9","buttonText":"table-header_buttonText__2bvtl"};